import React from 'react';

interface AboutSectionProps {
  description: string;
}

const AboutSection: React.FC<AboutSectionProps> = ({ description }) => {
  return (
    <div className="px-6 mb-6">
      <div className="p-4 rounded-lg border border-gray-200">
        <p className="text-sm leading-relaxed">
          {description}
        </p>
      </div>
    </div>
  );
};

export default AboutSection;